/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertDomain } from './AlertDomain';
import {
    AlertDomainFromJSON,
    AlertDomainFromJSONTyped,
    AlertDomainToJSON,
    AlertDomainToJSONTyped,
} from './AlertDomain';

/**
 * API Alert data model with required fields for API operations.
 * @export
 * @interface APIAlert
 */
export interface APIAlert {
    /**
     * Unique identifier for the alert using UUID v4
     * @type {string}
     * @memberof APIAlert
     */
    id: string;
    /**
     * Instance ID associated with the alert (equivalent to platform_id, install_base_id)
     * @type {string}
     * @memberof APIAlert
     */
    instanceId: string;
    /**
     * Domain of alert (e.g. capacity, network)
     * @type {AlertDomain}
     * @memberof APIAlert
     */
    domain: AlertDomain;
    /**
     * Timestamp when the alert was added to BigQuery
     * @type {Date}
     * @memberof APIAlert
     */
    createdAt: Date;
    /**
     * Date when the alert was originally generated
     * @type {Date}
     * @memberof APIAlert
     */
    alertDate: Date;
    /**
     * Detailed description of the alert
     * @type {string}
     * @memberof APIAlert
     */
    description: string;
    /**
     * Current status of the alert
     * @type {string}
     * @memberof APIAlert
     */
    status: APIAlertStatusEnum;
    /**
     * Severity level of the alert
     * @type {string}
     * @memberof APIAlert
     */
    severity: APIAlertSeverityEnum;
}


/**
 * @export
 */
export const APIAlertStatusEnum = {
    Active: 'Active',
    Resolved: 'Resolved'
} as const;
export type APIAlertStatusEnum = typeof APIAlertStatusEnum[keyof typeof APIAlertStatusEnum];

/**
 * @export
 */
export const APIAlertSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;
export type APIAlertSeverityEnum = typeof APIAlertSeverityEnum[keyof typeof APIAlertSeverityEnum];


/**
 * Check if a given object implements the APIAlert interface.
 */
export function instanceOfAPIAlert(value: object): value is APIAlert {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('instanceId' in value) || value['instanceId'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('alertDate' in value) || value['alertDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    return true;
}

export function APIAlertFromJSON(json: any): APIAlert {
    return APIAlertFromJSONTyped(json, false);
}

export function APIAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'instanceId': json['instance_id'],
        'domain': AlertDomainFromJSON(json['domain']),
        'createdAt': (new Date(json['created_at'])),
        'alertDate': (new Date(json['alert_date'])),
        'description': json['description'],
        'status': json['status'],
        'severity': json['severity'],
    };
}

export function APIAlertToJSON(json: any): APIAlert {
    return APIAlertToJSONTyped(json, false);
}

export function APIAlertToJSONTyped(value?: APIAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'instance_id': value['instanceId'],
        'domain': AlertDomainToJSON(value['domain']),
        'created_at': ((value['createdAt']).toISOString()),
        'alert_date': ((value['alertDate']).toISOString()),
        'description': value['description'],
        'status': value['status'],
        'severity': value['severity'],
    };
}

